import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { hankePage } from '@/views/hanke';
import { computed, ref, watchEffect } from 'vue';
import { useHuonekorttiTable } from '../huonekortit/table/huonekorttiTable';
import ComHistoria from '@/components/huonekortti/historia/ComHistoria.vue';
import { useHuonekortitViimmeisimmatMuutokset } from '@/methods/huonekorttiHistoriaComposables';
import ComLoading from '@/components/common/ComLoading.vue';
import ComPagination from '@/components/common/ComPagination.vue';
import { useKayttaja } from '@/methods/kayttajaComposables';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHankeHistoria',
  setup(__props) {

const { selectedVastuuyksikkoIds } = hankePage()
const { historia, loading, paramsObject, total } = useHuonekortitViimmeisimmatMuutokset()
const { formatTilat } = useHuonekorttiTable()
const { perPage } = useKayttaja()
const id = ref<number>()
const showDrawer = computed(() => !!id.value)
const vastuuyksikkoSelected = computed(() => selectedVastuuyksikkoIds.value && selectedVastuuyksikkoIds.value.length > 0)

const currentPage = computed({
    get: () => paramsObject.value.paging?.currentPage ?? 1,
    set: (value: number) => {
        if (paramsObject.value.paging) {
            paramsObject.value.paging.currentPage = value
        }
    }
})


watchEffect(() => {
    paramsObject.value.vastuuyksikot = selectedVastuuyksikkoIds.value
})

watchEffect(() => {
    if (paramsObject.value.paging && perPage.value) {
        paramsObject.value.paging.pageSize = perPage.value
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(ComLoading, null, null, 512), [
      [_vShow, _unref(loading)]
    ]),
    _withDirectives(_createVNode(_component_el_empty, { description: "Valitse vähintään yksi vastuuyksikkö!" }, null, 512), [
      [_vShow, !vastuuyksikkoSelected.value]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(ComPagination, {
                total: _unref(total),
                "page-size": _unref(paramsObject).paging?.pageSize,
                "current-page": currentPage.value,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                style: {"float":"right"}
              }, null, 8, ["total", "page-size", "current-page"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_table, {
        data: _unref(historia),
        loading: _unref(loading)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "aika",
            label: "Muutosaika"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_link, {
                type: "primary",
                onClick: ($event: any) => (id.value = scope.row.huonekortti.id)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.aika.substring(9)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Tekijä" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_link, {
                type: "primary",
                onClick: ($event: any) => (id.value = scope.row.huonekortti.id)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.kayttaja.etunimi + ' ' + scope.row.kayttaja.sukunimi), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "huonekortti.tilanimike.nimi",
            label: "Tilanimike"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: { name: 'Huonekortti', params: { huonekorttiId: scope.row.huonekortti.id } },
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    href: href,
                    onClick: navigate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.huonekortti.tilanimike.nimi), 1)
                    ]),
                    _: 2
                  }, 1032, ["href", "onClick"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "huonekortti.toiminta",
            label: "Täsmennys",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "huonekortti.tilat",
            label: "Tilat",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(formatTilat)(scope.row.huonekortti.tilat)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "loading"])
    ], 512), [
      [_vShow, !_unref(loading) && vastuuyksikkoSelected.value]
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: showDrawer.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDrawer).value = $event)),
      title: "Muutos",
      size: '50%',
      onClosed: _cache[2] || (_cache[2] = ($event: any) => (id.value = undefined))
    }, {
      default: _withCtx(() => [
        (id.value)
          ? (_openBlock(), _createBlock(ComHistoria, {
              key: 0,
              id: id.value
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})